var _defineProperty = require("@babel/runtime/helpers/defineProperty");

var _breakpoints;

var breakpointsEnum = {
  xs1: 'xs1',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var breakpoints = (_breakpoints = {}, _defineProperty(_breakpoints, breakpointsEnum.xs1, {
  min: 0,
  max: 320
}), _defineProperty(_breakpoints, breakpointsEnum.xs, {
  min: 321,
  max: 767
}), _defineProperty(_breakpoints, breakpointsEnum.sm, {
  min: 768,
  max: 959
}), _defineProperty(_breakpoints, breakpointsEnum.md, {
  min: 960,
  max: 1279
}), _defineProperty(_breakpoints, breakpointsEnum.lg, {
  min: 1280
}), _breakpoints);
var mediaQuery = {
  xs1: "(max-width: ".concat(breakpoints.xs1.max, "px)"),
  xs: "(max-width: ".concat(breakpoints.xs.max, "px)"),
  sm: "(min-width: ".concat(breakpoints.sm.min, "px) and (max-width: ").concat(breakpoints.sm.max, "px)"),
  smMax: "(max-width: ".concat(breakpoints.sm.max, "px)"),
  smMin: "(min-width: ".concat(breakpoints.sm.min, "px)"),
  md: "(min-width: ".concat(breakpoints.md.min, "px) and (max-width: ").concat(breakpoints.md.max, "px)"),
  mdMax: "(max-width: ".concat(breakpoints.md.max, "px)"),
  mdMin: "(min-width: ".concat(breakpoints.md.min, "px)"),
  lg: "(min-width: ".concat(breakpoints.lg.min, "px)"),
  notXs: 'not all and (--xs-viewport)',
  notSm: 'not all and (--sm-viewport)',
  notMd: 'not all and (--md-viewport)',
  notLg: 'not all and (--lg-viewport)'
};
var customMedia = {
  '--xs1-viewport': mediaQuery.xs1,
  '--xs-viewport': mediaQuery.xs,
  '--sm-viewport': mediaQuery.sm,
  '--sm-max-viewport': mediaQuery.smMax,
  '--sm-min-viewport': mediaQuery.smMin,
  '--md-viewport': mediaQuery.md,
  '--md-max-viewport': mediaQuery.mdMax,
  '--md-min-viewport': mediaQuery.mdMin,
  '--lg-viewport': mediaQuery.lg,
  '--not-xs-viewport': mediaQuery.notXs,
  '--not-sm-viewport': mediaQuery.notSm,
  '--not-md-viewport': mediaQuery.notMd,
  '--not-lg-viewport': mediaQuery.notLg,
  '--no-motion': 'screen and (prefers-reduced-motion: reduce)'
};
module.exports = {
  mediaQuery: mediaQuery,
  customMedia: customMedia,
  breakpoints: breakpoints,
  breakpointsEnum: breakpointsEnum
};